import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import colors from '../../../../../constants/colors';
import PublicationInfo from '../PublicationInfo';
import { path } from '../../../../../routing/helpers/router';
import minions from '../../../../../minions/minions';

export default function UserItemListView({ elementID }) {
  const { moduleBridgeHex } = useParams();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.currentPage?.options?.loading);
  const itLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );
  const itLevel2 = useSelector(
    (state) => state.currentPage?.elementLevels?.level2?.[elementID]
  );
  const [showInfoModal, setShowInfoModal] = useState(false);

  const handleClick = useCallback(() => {
    if (!itLevel1 || loading) return;

    if (itLevel1?.isFolder) {
      navigate(
        path({
          name: 'user_module_documentManager_item_list',
          params: {
            moduleBridgeHex,
            parentItemHex: itLevel1?.hex,
            page: 1,
            filtersHex: 0,
          },
        })
      );
    } else {
      setShowInfoModal(true);
    }
  }, [itLevel1, moduleBridgeHex]);

  const renderTags = useCallback(
    () =>
      itLevel1?.tags?.map((t) => (
        <span
          key={t?.key}
          className="badge badge-xs ml-1 pl-1 pr-1"
          style={{
            backgroundColor: colors.paletteColors[t?.color],
            color: '#fff',
          }}
        >
          {t?.name}
        </span>
      )),
    [itLevel1]
  );

  return (
    <>
      <Container
        key={elementID}
        className="pt-1 pr-2 pb-3 pl-2"
        onDoubleClick={handleClick}
      >
        <div className="col-title" title="Información del documento">
          <span>
            {itLevel1?.isFolder && <AppRemixIcon icon="folder" filled />}
            {itLevel1?.fileName &&
              minions.files.fileIcon(itLevel1?.fileName)}{' '}
            {itLevel1?.title || '...'}
          </span>
        </div>
        <div>{renderTags()}</div>
      </Container>
      <AppModal
        show={showInfoModal && itLevel2}
        title="Información"
        size="xl"
        onClose={() => setShowInfoModal(false)}
      >
        <PublicationInfo
          elementID={elementID}
          onClose={() => setShowInfoModal(false)}
        />
      </AppModal>
    </>
  );
}

const Container = styled.div`
  border-bottom: solid 1px lightgrey;
  overflow: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;

  .col-title {
    cursor: default;
  }
  .col-options {
    display: flex;
    justify-content: end;
    .options {
      display: none;
    }
  }

  &:hover {
    .options {
      display: flex;
    }
  }
`;
